import React, { Component } from 'react';
import {
    Form,
    Button,
    Card,
    Alert,
    Row,
    Col,
    Badge
} from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import {
    FaTag,
    FaMoneyBillWave,
    FaWallet,
    FaChartPie,
    FaSave,
    FaTimes,
    FaEdit,
    FaInfoCircle,
    FaArrowDown,
    FaArrowUp
} from 'react-icons/fa';
import './CreateCategoryForm.css';

class CreateCategoryForm extends Component {
    bookId = JSON.parse(localStorage.bookId);

    constructor(props) {
        super(props);
        this.state = {
            Id: props.data?.id || '',
            bookId: this.bookId,
            name: props.data?.name || '',
            desc: props.data?.desc || '',
            type: props.data?.type || '',
            budget: props.data?.budget ,
            validated: false,
            update: props.update || false,
            loading: false,
            error: null,
            success: false
        }
    }

    categoryTypes = [
        {
            value: '1',
            label: 'Pemasukan',
            icon: FaArrowDown,
            color: 'success',
            description: 'Kategori untuk pendapatan dan pemasukan',
            gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
        },
        {
            value: '2',
            label: 'Pengeluaran',
            icon: FaArrowUp,
            color: 'warning',
            description: 'Kategori untuk pengeluaran dan belanja',
            gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
        }
    ]

    getTypeInfo = (typeValue) => {
        return this.categoryTypes.find(type => type.value === typeValue) || this.categoryTypes[0];
    }

    validateForm = () => {
        const { name, desc, type } = this.state;
        return name && desc && type;
    }

    saveCategory = async (e) => {
        e.preventDefault();
        
        if (!this.validateForm()) {
            this.setState({ 
                validated: true, 
                error: "Harap lengkapi semua field yang wajib diisi" 
            });
            return;
        }

        this.setState({ loading: true, error: null, success: false });

        try {
            await this.props.action(this.state);
            this.setState({ success: true });
            
            setTimeout(() => {
                this.props.handleClose();
            }, 1500);

        } catch (error) {
            console.error("Error saving category:", error);
            this.setState({ 
                error: "Gagal menyimpan kategori. Silakan coba lagi.", 
                loading: false 
            });
        }
    }

    renderTypeSelector = () => {
        const { type } = this.state;

        return (
            <Form.Group className="mb-4">
                <Form.Label className="form-label">
                    <FaChartPie className="me-2" />
                    Jenis Kategori
                </Form.Label>
                <Row>
                    {this.categoryTypes.map((categoryType) => {
                        const IconComponent = categoryType.icon;
                        const isSelected = type === categoryType.value;
                        
                        return (
                            <Col md={6} key={categoryType.value}>
                                <div 
                                    className={`type-card ${isSelected ? 'selected' : ''}`}
                                    onClick={() => this.setState({ type: categoryType.value })}
                                >
                                    <div className="type-icon">
                                        <IconComponent />
                                    </div>
                                    <div className="type-content">
                                        <h6>{categoryType.label}</h6>
                                        <small>{categoryType.description}</small>
                                    </div>
                                    <div className="type-check">
                                        {isSelected && <div className="checkmark">✓</div>}
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </Form.Group>
        );
    }

    renderBudgetSection = () => {
        const typeInfo = this.getTypeInfo(this.state.type);
        const isExpense = this.state.type === '2';

        return (
            <Form.Group className="mb-3">
                <Form.Label className="form-label">
                    <FaMoneyBillWave className="me-2" />
                    {isExpense ? 'Anggaran Bulanan' : 'Target Pemasukan'}
                    <small className="text-muted ms-2">(Opsional)</small>
                </Form.Label>
                
                <div className="budget-container">
                    <CurrencyInput
                        className="form-control modern-currency-input"
                        placeholder={`Masukkan ${isExpense ? 'anggaran' : 'target'} bulanan`}
                        defaultValue={this.state.budget}
                        decimalsLimit={2}
                        intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                        onValueChange={(value) => this.setState({ budget: value })}
                    />
                    
                    {this.state.budget && (
                        <div className="budget-preview">
                            <Badge bg={typeInfo.color} className="budget-badge">
                                {isExpense ? 'Anggaran: ' : 'Target: '}
                                Rp {parseFloat(this.state.budget).toLocaleString('id-ID')}
                            </Badge>
                        </div>
                    )}
                </div>
                
                {isExpense && this.state.budget && (
                    <Form.Text className="budget-help">
        💡 Anggaran membantu mengontrol pengeluaran bulanan Anda
                    </Form.Text>
                )}
            </Form.Group>
        );
    }

    render() {
        const { update, type } = this.state;
        const typeInfo = this.getTypeInfo(type);

        return (
            <div className="create-category-form-modern">
                <Card className="category-form-card">
                    <Card.Header className="category-form-header">
                        <div className="d-flex align-items-center">
                            <div className="header-icon">
                                {update ? <FaEdit /> : <FaTag />}
                            </div>
                            <div>
                                <h4 className="mb-0">
                                    {update ? 'Edit Kategori' : 'Buat Kategori Baru'}
                                </h4>
                                {type && (
                                    <Badge bg={typeInfo.color} className="mt-1 type-badge">
                                        {typeInfo.label}
                                    </Badge>
                                )}
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body>
                        {this.state.error && (
                            <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                                {this.state.error}
                            </Alert>
                        )}

                        {this.state.success && (
                            <Alert variant="success">
                                {update ? 'Kategori berhasil diperbarui!' : 'Kategori berhasil dibuat!'}
                            </Alert>
                        )}

                        <Form 
                            id="createCategoryForm" 
                            validated={this.state.validated}  
                            onSubmit={this.saveCategory}
                            className="category-form"
                        >
                            {this.renderTypeSelector()}

                            <Row>
                                <Col md={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            Nama Kategori
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.name}
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                            placeholder={`Contoh: ${type === '1' ? 'Gaji, Bonus, Investasi' : 'Makanan, Transportasi, Hiburan'}`}
                                            required
                                            className="modern-input"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            Warna
                                            <small className="text-muted ms-2">(Coming Soon)</small>
                                        </Form.Label>
                                        <div className="color-preview">
                                            <div 
                                                className="color-circle"
                                                style={{ 
                                                    background: typeInfo.gradient,
                                                    cursor: 'not-allowed'
                                                }}
                                            ></div>
                                            <span className="color-label">Auto</span>
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label className="form-label">
                                    <FaInfoCircle className="me-2" />
                                    Deskripsi
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={this.state.desc}
                                    onChange={(e) => this.setState({ desc: e.target.value })}
                                    placeholder="Deskripsi detail tentang kategori ini..."
                                    required
                                    className="modern-textarea"
                                />
                            </Form.Group>

                            {this.state.type && this.renderBudgetSection()}

                            <div className="form-actions">
                                <Button
                                    variant="outline-secondary"
                                    onClick={this.props.handleClose}
                                    className="action-btn"
                                    disabled={this.state.loading}
                                >
                                    <FaTimes className="me-2" />
                                    Batal
                                </Button>
                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={this.state.loading}
                                    className="action-btn submit-btn"
                                >
                                    {this.state.loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Menyimpan...
                                        </>
                                    ) : (
                                        <>
                                            <FaSave className="me-2" />
                                            {update ? 'Perbarui Kategori' : 'Simpan Kategori'}
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default CreateCategoryForm;